/* eslint-disable @typescript-eslint/default-param-last */
import { IGetLibraryProblemType } from '../../types/Interviews/problem.types';
import { GET_LIBRARY_PROBLEMS } from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

const libraryReducer = (
  state = initialState.interviewLibrary,
  action: IGetLibraryProblemType
) => {
  switch (action.type) {
    case `${GET_LIBRARY_PROBLEMS}_SUCCESS`:
      return {
        ...state,
        problems: action.payload.results,
        meta: action.payload.meta,
      };
    default:
      return state;
  }
};

export default libraryReducer;
